// extracted by mini-css-extract-plugin
module.exports = {"details":"CommitmentInfo_details__YLGBt"};